<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      flat
      class="my-0 py-1 mb-2 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>{{ $t($route.name, { name: $store.state.studentLabel }) }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f5']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="getItems"
            v-on="on"
            @click="getItems"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('refresh') }}(f5)</span>
      </v-tooltip>
<log
        ref="logRef"
        v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
        :type-prop="type"
        mode-prop="button"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo('customer')"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('newCustomer') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-row class="mx-0 mt-2">
      <v-col
        cols="12"
        md="3"
      >
        <autocomplete
          v-model="event"
          title="academyEventName"
          type="academyEvent"
          :value="event"
        />
      </v-col>
      <v-col
        v-if="event && event.type == 'interview'"
        cols="12"
        md="4"
      >
        <autocomplete
          v-model="session"
          title="academySession"
          type="academySession"
          :value="session"
          :data="JSON.stringify({parent: event.id})"
        />
      </v-col>
      <v-col
        v-if="event"
        cols="12"
      >
        <v-chip
          class="ma-2 ms-0"
          color="teal"
          label
          text-color="white"
        >
          <v-icon left>
            mdi-office-building-outline
          </v-icon>
          {{ $t('startDate') }} {{ event.start_date }}
        </v-chip>
        <v-chip
          class="ma-2 ms-0"
          color="blue"
          label
          text-color="white"
        >
          <v-icon left>
            mdi-office-building-outline
          </v-icon>
          {{ $t('startTime') }} {{ event.start_time }}
        </v-chip>
        <v-chip
          class="ma-2 ms-0"
          color="blue"
          label
          text-color="white"
        >
          <v-icon left>
            mdi-office-building-outline
          </v-icon>
          {{ $t('sessionCount') }} {{ event.session_count }}
        </v-chip>
        <v-chip
          v-if="event.teacher"
          class="ma-2 ms-0"
          color="amber"
          label
          text-color="brown"
        >
          <v-icon left>
            mdi-office-building-outline
          </v-icon>
          {{ $t('teacher') }} {{ event.teacher.name }}
        </v-chip>
        <v-chip
          v-if="event.place"
          class="ma-2 ms-0"
          color="deep-orange"
          label
          text-color="white"
        >
          <v-icon left>
            mdi-office-building-outline
          </v-icon>
          {{ $t('place') }} {{ $t('class') }} {{ event.place.name }}
        </v-chip>
        <v-chip
          v-if="event.arrayDays && event.arrayDays.length > 0"
          class="ma-2 ms-0"
          color="primary"
          label
          text-color="white"
        >
          {{ $t('daysHolding') }}
        </v-chip>
        <v-chip
          v-for="(day, index) in event.arrayDays"
          :key="index"
          color="primary"
          label
          style="margin-left: 1px;margin-right:1px"
          class="px-1"
        >
          <span class="px-1 white--text">
            {{ $t(day) }}
          </span>
        </v-chip>
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col
        class="pb-2 px-2"
        cols="12"
        md="6"
      >
        <v-col
          class="pb-2 px-2"
          cols="12"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            flat
            solo
            height="30"
            background-color="#e5e5e5"
            dense
            clearable
          />
        </v-col>
        <v-col
          cols="12"
          class="px-2 mt-2"
          style="border: 1px solid #e3e3e3;border-radius: 5px;}"
        >
          <v-data-table
            v-if="headers"
        :height="tableHeight"
        fixed-header
            ref="datatable"
            v-model="selected"
            :headers="showHeaders"
            :items="items"
            :options.sync="options"
            :server-items-length="totalItems"
            :loading="loading"
            :show-select="showSelect"
            multi-sort
            item-key="id"
            :footer-props="{
              showFirstLastPage: true,
              itemsPerPageOptions: [10, 25, 50, 100, 500],
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-plus',
              nextIcon: 'mdi-minus'
            }"
          >
            <template v-slot:item.actions="{ item }">
              <v-menu
                offset-y
              >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    color="primary"
                    v-bind="attrs"
                    icon
                    v-on="on"
                  >
                    <v-icon
                      medium
                    >
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item
                    link
                    @click="edit(item)"
                  >
                    <v-list-item-icon>
                      <v-icon class="mt-2">
                        mdi-clipboard-edit
                      </v-icon>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            icon
                            small
                            v-on="on"
                            @click.stop.prevent="newTab('customerEdit', item)"
                          >
                            <v-icon
                              small
                              color="primary"
                            >
                              mdi-content-duplicate
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('newTab') }}</span>
                      </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-title v-text="$t('edit')" />
                  </v-list-item>
                  <v-list-item
                    link
                    @click="turnover(item)"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-recycle-variant</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title v-text="$t('turnover')" />
                  </v-list-item>
                  <v-list-item
                    v-clipboard:copy="$baseURL + '/customer/edit/' + item.id"
                    link
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-link</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title v-text="$t('copy-link')" />
                  </v-list-item>
                  <v-list-item
                    link
                    @click="openDeleteDialog(item)"
                  >
                    <v-list-item-icon>
                      <v-icon color="pink">
                        mdi-trash-can-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title v-text="$t('remove')" />
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.firstname="{ item }">
              <a @click="edit(item)">
                {{ item.firstname }} {{ (item.lastname ? item.lastname : '') }} {{ (item.code ? '(' + item.code + ')' : '') }}
              </a>
            </template>
            <template v-slot:item.row="{ item }">
              {{ parseInt(items.indexOf(item))+ parseInt(from) }}
            </template>
            <template v-slot:item.id="{ item }">
              <a @click="edit(item)">
                {{ item.id }}
              </a>
            </template>
            <template v-slot:item.tags="{ item }">
              <div
                class="pt-1"
                @click="edit(item)"
              >
                <v-chip
                  v-for="(tag, index) in item.tags"
                  :key="index"
                  :color="tag.color"
                  label
                  small
                  style="margin-left: 1px;margin-right:1px"
                  class="px-1 mb-1"
                >
                  <span class="px-1 white--text">
                    {{ tag.text }}
                  </span>
                </v-chip>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <div
                v-if="event"
                class="pt-1"
              >
                <v-btn
                  small
                  color="primary"
                  @click="openAddToEventDialog(item)"
                >
                  {{ $t('addToEvent') }}
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-col>
      <v-col
        class="pb-2 px-2"
        cols="12"
        md="6"
      >
        <v-subheader inset>
          {{ $t('registeredStudents', {name: $store.state.studentLabel}) }}
        </v-subheader>
        <v-col
          class="pb-2 px-2"
          cols="12"
          style="border: 1px solid #e3e3e3;border-radius: 5px;}"
        >
          <v-list style=" height:308px;overflow-y:auto">
            <v-list-item-group
              active-class="pink--text"
              multiple
            >
              <template>
                <v-list-item
                  v-for="(student, i) in students"
                  :key="i"
                  dense
                  style="border-bottom: 1px solid #e3e3e3"
                >
                  <template v-slot:default="{}">
                    <v-list-item-avatar class="my-0">
                      {{ +i + +1 }}
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title v-text="student.name" />
                    </v-list-item-content>

                    <v-list-item-action class="my-0 d-inline">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            icon
                            v-on="on"
                            @click="sendSmsStudentEvent(student)"
                          >
                            <v-icon
                              color="blue"
                            >
                              mdi-message-reply-text-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('sendRegisterSms') }}</span>
                      </v-tooltip>
                      <v-btn
                        icon
                        @click="removeStudent(student)"
                      >
                        <v-icon color="pink">
                          mdi-delete-outline
                        </v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
          <v-card-actions>
            <!--            <v-btn-->
            <!--              color="green"-->
            <!--              class="ms-2"-->
            <!--              @click="submit"-->
            <!--            >-->
            <!--              {{ $t('submit') }}-->
            <!--            </v-btn>-->
            <v-spacer />
          </v-card-actions>
        </v-col>
      </v-col>
    </v-row>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="addToEventDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="addToEventDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('doYouSureToAddStudent', {name: $store.state.studentLabel}) }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="10">
              <v-btn
                color="primary"
                small
                @click="addToEvent('deactive')"
              >
                {{ $t('addStudent', {name: $store.state.studentLabel}) }}
              </v-btn>
              <v-btn
                color="green"
                style="margin-right: 8px !important;"
                small
                @click="addToEvent('active')"
              >
                {{ $t('addStudentWithSms', {name: $store.state.studentLabel}) }}
              </v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                small
                @click="addToEventDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col md="2">
            <v-checkbox
              v-model="lead"
              class="mt-0"
              :label="$t('lead')"
              value="active"
              style="height: 20px"
            />
          </v-col>
          <v-col md="2">
            <v-checkbox
              v-model="status"
              class="mt-0"
              :label="$t('active')"
              value="active"
              style="height: 20px"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="financialStatus"
              :label="$t('financial-status')"
              :items="financialStatusItems"
              height="32"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="category"
              :title="$t('category')"
              type="accountCategory"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="attractionMethod"
              :title="$t('attractionMethod')"
              type="attractionMethod"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            ref="refTask"
            task-type="account"
            :ref-item="taskItem"
            ref-type="account"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialogList"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialogList = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('tasks') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task-list
            ref="refTaskList"
            type="account"
            :ref-id="refId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="customer"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import TaskList from '../task/list'
  import Upload from '../../components/general/upload/upload'
  import General from '../../../../Mixins/general'
  import Print from '../../components/general/Print/Index'
  // import pdfPrint from '../../components/general/Print/pdfPrintTable'
  export default {
    name: 'StudentList',
    components: {
      Tag: () => import('../../components/general/Tag/tag'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Print,
      Task,
      // pdfPrint,
      TaskList,
      Upload,
    },
    mixins: [General],
    props: ['eventProp', 'sessionProp'],
    data: () => ({
      selected: [],
      eventStudentReq: true,
      session: null,
      event: null,
      excelItems: null,
      category: null,
      integratorType: null,
      rangeDate: null,
      registerar: null,
      attractionMethod: null,
      customerStatusItems: null,
      financialStatusItems: null,
      addToEventDialog: false,
      student: null,
      printDialog: false,
      uploadDialog: false,
      accountDialog: false,
      deletDialog: false,
      filter: false,
      financialStatus: null,
      customerStatus: null,
      status: 'active',
      taskindex: 0,
      lead: null,
      refId: null,
      taskItem: null,
      model: null,
      from: 1,
      taskDialog: null,
      taskDialogList: null,
      showSelect: null,
      tag: null,
      temp: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbarColor: null,
      snakbar: false,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      deleteItem: null,
      students: [],
      headers: null,
      personnel: null,
      id: null,
      search: null,
      renderTable: null,
      selectedHeaders: [],
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
    },
    watch: {
      taskDialogList (val, old) {
        if (!val) {
          this.getItems()
        }
      },
      taskDialog (val, old) {
        if (!val) {
          this.getItems()
        }
      },
      data (val, oldVal) {
        this.model = val.description
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          app.page = app.options.page
          app.itemsPerPage = app.options.itemsPerPage
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      event (val) {
        if (val) {
          this.getStudents()
        } else {
          this.students = []
        }
      },
      session (val) {
        if (val) {
          this.getStudents()
        } else {
          this.students = []
        }
      },
    },
    activated () {
      this.getItems()
    },
    beforeMount () {
      this.customerStatusItems = [
        {
          value: 'lead',
          text: this.$t('lead'),
        },
        {
          value: 'on',
          text: this.$t('active'),
        },
      ]
      this.financialStatusItems = [
        {
          value: '>',
          text: this.$t('debtor'),
        },
        {
          value: '<',
          text: this.$t('creditor'),
        },
        {
          value: '=',
          text: this.$t('clearing'),
        },
      ]
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          table: 'users.id',
          width: 20,
        },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'users.id',
        },
        {
          text: this.$t('name'),
          sortable: true,
          value: 'firstname',
          table: 'users.name',
        },
        {
          text: this.$t('national-code'),
          sortable: true,
          value: 'national_code',
          table: 'users.national_code',
        },
        {
          text: this.$t('tag'),
          sortable: false,
        },
        {
          text: this.$t('actions'),
          sortable: false,
          value: 'action',
        },
      ]
      if (this.eventProp) {
        this.event = this.eventProp
      }
      if (this.sessionProp) {
        this.session = this.sessionProp
      }
    },
    mounted () {
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      if (this.input) {
        this.model = this.input
      }
      // this.getItems()
    },
    methods: {
      openAddToEventDialog (item) {
        this.student = item
        this.addToEventDialog = true
      },
      removeStudent (item) {
        const i = this.students.indexOf(item)
        if (i > -1) {
          this.students.splice(i, 1)
        }
        var data = {
          event: this.event,
          session: this.session,
          student: item,
        }
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'academyStudents/' + item.registerId, { data: data })
          .then(res => {
            res = res.data
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      submit (student, sms) {
        if (!this.event) {
          return false
        }
        var app = this
        app.addToEventDialog = false
        app.loading = true
        app.clearing = true
        app.showing = true
        var data = {
          event: this.event,
          session: this.session,
          student: student,
          sms: sms,
        }
        app.$axios.post(this.$endpoint + 'academyStudents', data)
          .then(res => {
            res = res.data
            student.registerId = res.data.id
            app.student = null
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      sendSmsStudentEvent (student) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'academyStudents', {
          params: {
            sendSmsStudentEvent: 'active',
            event: app.event,
            student: student,
          },
        })
          .then(res => {
            res = res.data
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      getStudents () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'academyStudents', {
          params: {
            getEventStudents: 'active',
            eventId: app.event.id,
            sessionId: (app.session ? app.session.id : null),
          },
        })
          .then(res => {
            res = res.data
            app.students = res
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      addToEvent (sms) {
        var student = {
          id: this.student.id,
          name: this.student.name,
          registerId: null,
        }
        const i = this.students.findIndex(h => h.id === this.student.id)
        if (i > -1) {
          this.snakbarColor = 'pink'
          this.snakbarText = this.$t('iterationStudent', { name: this.$store.state.studentLabel })
          this.snakbar = true
          return false
        }
        this.students.push(student)
        this.submit(student, sms)
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'customerEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'customer/show', {
          params: {
            search: app.search,
            registerar: app.registerar,
            rangeDate: app.rangeDate,
            category: app.category,
            attractionMethod: app.attractionMethod,
            status: app.status,
            personnel: app.personnel,
            lead: app.lead,
            page: app.page,
            type: app.type,
            sortBy: app.sortBy,
            integratorType: app.integratorType,
            options: app.options,
            tag: app.tag,
            customerStatus: app.customerStatus,
            remainStatus: app.financialStatus,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.last_page = res.last_page
            app.from = res.from
            // const table = this.$refs.datatable.$el.querySelector('table')
            // const [header] = table.tHead.rows
            // const props = [...header.cells].map(h => h.textContent)
            // const rows = [...table.rows].map(r => {
            //   const entries = [...r.cells].map((c, i) => {
            //     return [props[i], c.textContent]
            //   })
            //   return Object.fromEntries(entries)
            // })
            // app.renderTable = this.$refs.datatable.$el.querySelector('thead')
          })
          .catch(err => {
            var error = err.response
            if (error.status === 401) {
              this.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true

        app.$axios.delete(this.$endpoint + 'customer/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'customer/0', {
          params: { deleteItems: app.selected },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      print () {
        this.$htmlToPaper('print')
      },
      turnover (item) {
        this.$router.push({ name: 'turnover', params: { accountProp: { fin_id: item.fin_id, name: item.name } } })
      },
    },
  }
</script>

<style scoped>
.v-badge__badge {
  height: 16px !important;
  min-width: 16px !important;
  padding: 4px 6px !important;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: initial;
  min-height: 32px !important;
}
</style>
